import { reactive } from 'vue'
// 引入全部图标
// import * as Icons from "@element-plus/icons"

// 按需引入图标
import {
  CloseBold,
  Fold,
  Close,
  Expand,
  Minus,
  QuestionFilled,
  Memo,
  Plus,
  AlarmClock,
  CopyDocument,
  ArrowLeft,
  Star,
  ChatLineSquare,
  Histogram,
  Delete,
  Calendar,
  View,
  UserFilled,
  StarFilled,
  ArrowDown,
  Finished,
  Loading,
  ShoppingBag,
  ChromeFilled,
  SemiSelect,
  Connection,
  Position,
  Back,
  Edit,
  EditPen,
  CirclePlusFilled,
  Money,
  Timer,
  OfficeBuilding,
  CirclePlus,
  Select,
  Grid,
  HomeFilled,
  CreditCard,
  More,
  Picture,
  RemoveFilled,
  User,
  Upload,
  Reading,
  Refresh,
  FolderOpened,
  CollectionTag,
  DocumentAdd,
  RefreshLeft,
  FirstAidKit,
  Sunny,
  Moon,
  Search,
} from '@element-plus/icons-vue'

const dictIcon = reactive({
  CreditCard: CreditCard,
  Grid: Grid,
  Expand: Expand,
  HomeFilled: HomeFilled,
  Fold: Fold,
  CloseBold: CloseBold,
  ArrowLeft: ArrowLeft,
  Close: Close,
  Sunny: Sunny,
  Moon: Moon,
  Search: Search,
  Reading: Reading,
  RefreshLeft: RefreshLeft,
  Refresh: Refresh,
  ChatLineSquare: ChatLineSquare,
  Calendar: Calendar,
  SemiSelect: SemiSelect,
  QuestionFilled: QuestionFilled,
  View: View,
  Memo: Memo,
  ChromeFilled: ChromeFilled,
  CopyDocument: CopyDocument,
  Histogram: Histogram,
  CirclePlusFilled: CirclePlusFilled,
  ArrowDown: ArrowDown,
  EditPen: EditPen,
  RemoveFilled: RemoveFilled,
  DocumentAdd: DocumentAdd,
  Minus: Minus,
  CirclePlus: CirclePlus,
  Timer: Timer,
  Position: Position,
  ShoppingBag: ShoppingBag,
  Back: Back,
  Delete: Delete,
  StarFilled: StarFilled,
  AlarmClock: AlarmClock,
  Picture: Picture,
  More: More,
  FirstAidKit: FirstAidKit,
  User: User,
  OfficeBuilding: OfficeBuilding,
  CollectionTag: CollectionTag,
  Upload: Upload,
  Plus: Plus,
  Finished: Finished,
  Select: Select,
  Money: Money,
  Star: Star,
  UserFilled: UserFilled,
  Loading: Loading,
  Connection: Connection,
  Edit: Edit,
  FolderOpened: FolderOpened,
})

const installIcon = (app) => {
  // 便于模板获取
  app.config.globalProperties.$icon = dictIcon
  // 使用全部图标
  // app.config.globalProperties.$icon = Icons
}

export default installIcon
